module.exports = __webpack_public_path__ + "img/Player2024.924e424c.png";